import Dashboard from "views/merchants/MerchantDashboard.js"
import Login from "views/pages/Login.js"
import Profile from "views/merchants/Profile.js"
import Register from "views/pages/Register.js"
import Orders from "views/merchants/Orders.jsx"
import AccountDetails from "views/merchants/AccountDetails.jsx"

const merchantRoutes = [
  {
    name: "Dashboard",
    icon: "fas fa-columns text-primary",
    path: "/dashboard",
    component: Dashboard,
    layout: "/m",
    visible: true,
  },
  {
    name: "Orders",
    icon: "fas fa-receipt text-primary",
    path: "/orders",
    component: Orders,
    layout: "/m",
    visible: true,
  },
  {
    path: "/profile",
    name: "Profile",
    icon: "fas fa-store text-primary",
    miniName: "P",
    component: Profile,
    layout: "/m",
    visible: true,
  },
  {
    path: "/account",
    name: "Account Details",
    icon: "fa fa-credit-card text-primary",
    miniName: "A",
    component: AccountDetails,
    layout: "/m",
    visible: true,
  },
  {
    path: "/login",
    name: "Login",
    miniName: "L",
    component: Login,
    layout: "/a",
    visible: false,
  },
  {
    path: "/register",
    name: "Register",
    miniName: "R",
    component: Register,
    layout: "/a",
    visible: false,
  },
]

export default merchantRoutes
